<template>
  <div>
    <b-card>
      <b-col cols="6">
        <h4>API-Response Json Formatter</h4>
      </b-col>
    </b-card>

    <b-tabs>
      <b-tab
        v-for="template in templates"
        :key="template.title"
        :title="template.title"
      >
        <b-tabs pills>
          <b-tab
            v-for="page in template.pages"
            :key="page.page_no"
            :title="`Page ${page.page_no}`"
          >
            <div class="field-wrapper">
              <b-form @submit.prevent="handleSubmit(template.title, page.page_no)">
                <b-row v-for="(mapping, index) in page.mappings" :key="index">
                  <b-col cols="3">
                    <b-form-group :label-for="`${template.title}_${page.page_no}_${mapping.json_key}`">
                      <template #label>
                        {{ mapping.template_mapping_key }}:
                        <span
                          v-if="isFieldEdited(template.title, page.page_no, mapping.json_key)"
                          class="text-success ml-2"
                        >✔ Edited</span>
                      </template>
                      <b-form-input
                        :id="`${template.title}_${page.page_no}_${mapping.json_key}`"
                        v-model="formData[template.title][page.page_no][mapping.json_key]"
                        :placeholder="`Enter ${mapping.template_mapping_key.toLowerCase()}`"
                        @input="markEdited(template.title, page.page_no, mapping.json_key)"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-button type="submit" class="btn mt-auto btn-secondary btn-md" size="sm">Save</b-button>
              </b-form>
            </div>
          </b-tab>
        </b-tabs>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ApiResponseJsonFormatter',
  data () {
    return {
      templates: [],
      formData: {},
      editedFields: {}
    }
  },
  mounted () {
    this.loadStructureAndData()
  },
  methods: {
    async loadStructureAndData () {
      try {
        const structureRes = await axios.get('settings/api_response_json_formatter/api_response_keys')

        this.templates = structureRes.data
        this.initializeFormData()
      } catch (err) {
        console.error('Error loading form data:', err)
      }
    },

    initializeFormData () {
      this.templates.forEach(template => {
        this.$set(this.formData, template.title, {})
        this.$set(this.editedFields, template.title, {})

        // Handle both single page and array of pages
        const pages = Array.isArray(template.pages) ? template.pages : [template.pages]

        pages.forEach(page => {
          this.$set(this.formData[template.title], page.page_no, {})
          this.$set(this.editedFields[template.title], page.page_no, {})

          page.mappings.forEach(mapping => {
            this.$set(this.formData[template.title][page.page_no], mapping.json_key, mapping.json_key)
            this.$set(this.editedFields[template.title][page.page_no], mapping.json_key, false)
          })
        })
      })
    },

    markEdited (templateTitle, pageNo, jsonKey) {
      this.editedFields[templateTitle][pageNo][jsonKey] = true
    },

    isFieldEdited (templateTitle, pageNo, jsonKey) {
      return (
        this.editedFields &&
        this.editedFields[templateTitle] &&
        this.editedFields[templateTitle][pageNo] &&
        this.editedFields[templateTitle][pageNo][jsonKey]
      )
    },

    handleSubmit (templateTitle, pageNo) {
      const updatedFields = {}
      const pageData = this.formData[templateTitle][pageNo]
      const edited = this.editedFields[templateTitle][pageNo]

      // Find the current template and page to get mapping information
      const currentTemplate = this.templates.find(t => t.title === templateTitle)
      const pages = Array.isArray(currentTemplate.pages) ? currentTemplate.pages : [currentTemplate.pages]
      const currentPage = pages.find(p => p.page_no === pageNo)

      for (const key in edited) {
        if (edited[key]) {
          // Find the mapping to get the template_mapping_key
          const mapping = currentPage.mappings.find(m => m.json_key === key)
          if (mapping) {
            updatedFields[mapping.template_mapping_key] = pageData[key]
          }
        }
      }

      if (Object.keys(updatedFields).length === 0) {
        window.alert('No changes to save.')
        return
      }

      axios.post('settings/api_response_json_formatter/update_keys', {
        template_title: templateTitle,
        page_no: pageNo,
        data: updatedFields
      })
        .then(() => {
          window.alert('Changes saved!')
          for (const key in edited) {
            this.editedFields[templateTitle][pageNo][key] = false
          }
        })
        .catch(err => {
          console.error(err)
          window.alert('Failed to save changes.')
        })
    }
  }
}
</script>

<style scoped>
.card {
  background: #ebeff3;
  border-radius: 10px;
}

.field-wrapper {
  background: #ebeff3;
  padding: 12px;
  margin-bottom: 10px;
  border-radius: 8px;
}

.form-group label {
  font-weight: 500;
}

.text-success {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/apiResponseJsonFormatter.vue